import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, useState, useRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import TableActiveComponent from "./Components/TableActiveComponent";
import TableInactiveComponent from "./Components/TableInactiveComponent";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";

const IndexView = (props) => {
  const [activeTab, setactiveTab] = useState("1");
  const activeRef = useRef();

  const reloadInactiveRef = () => activeRef.current.setTokenAPI();

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col xs="12">
            <PegawaiSideBar active="riwayat_nikah" />

            <Card className="pegawai-rightbar">
              <CardBody>
                <div className="float-end">
                  {accessRole("create") ? (
                    <Link to="?riwayat_nikah&create">
                      <Button color="primary">Tambah Suami/Istri</Button>
                    </Link>
                  ) : null}
                </div>
                <CardTitle>Daftar Suami/Istri</CardTitle>
                <CardSubtitle className="mb-3">
                  Kelola Daftar Suami/Istri
                </CardSubtitle>
                <hr />
                <TableActiveComponent
                  ref={activeRef}
                  handleInactiveSuccess={reloadInactiveRef}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default IndexView;
